export default "__VITE_ASSET__BRjoTR6l__"